









import { Image } from "@/classes/TayehApi/Instance";
import {Component, Prop, Vue} from "vue-property-decorator"

    @Component
	export default class MarketplaceImage extends Vue {
        @Prop() image: Image;
        private loading = false;
		private error = false;

		
		public get showImage() : boolean {
			return !this.loading && this.image && !this.error
		}
		public get showPlaceholder(): boolean {
				return this.loading||this.error
		}
	}
